// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1L7ZS","emails":"CreateEditClinics_emails__eBlja","emailTagLabel":"CreateEditClinics_emailTagLabel__1PN5T"};